import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=09129240&scoped=true&lang=pug"
import script from "./addOrUpdate.vue?vue&type=script&lang=js"
export * from "./addOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./addOrUpdate.vue?vue&type=style&index=0&id=09129240&prod&scoped=true&lang=css"
import style1 from "./addOrUpdate.vue?vue&type=style&index=1&id=09129240&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09129240",
  null
  
)

export default component.exports